import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Admin {
  constructor() {
    _defineProperty(this, "settings", []);
    _defineProperty(this, "permissions", []);
    _defineProperty(this, "customPage", null);
    _defineProperty(this, "generalIndexes", {});
  }
  /**
   * Register a setting to be shown on the extension's settings page.
   */
  setting(setting, priority) {
    if (priority === void 0) {
      priority = 0;
    }
    this.settings.push({
      setting,
      priority
    });
    return this;
  }

  /**
   * Register a custom setting to be shown on the extension's settings page.
   */
  customSetting(setting, priority) {
    if (priority === void 0) {
      priority = 0;
    }
    this.settings.push({
      customSetting: setting,
      priority
    });
    return this;
  }

  /**
   * Register a permission to be shown on the extension's permissions page.
   */
  permission(permission, type, priority) {
    if (priority === void 0) {
      priority = 0;
    }
    this.permissions.push({
      permission,
      type,
      priority
    });
    return this;
  }

  /**
   * Register a custom page to be shown in the admin interface.
   */
  page(page) {
    this.customPage = page;
    return this;
  }

  /**
   * Register a custom general search index entry.
   */
  generalIndexItems(type, items) {
    this.generalIndexes[type] = items;
    return this;
  }
  extend(app, extension) {
    app.registry.for(extension.name);
    this.settings.forEach(_ref => {
      let {
        setting,
        customSetting,
        priority
      } = _ref;
      const settingConfig = setting ? setting() : customSetting;
      if (settingConfig) {
        app.registry.registerSetting(settingConfig, priority);
      }
    });
    this.permissions.forEach(_ref2 => {
      let {
        permission,
        type,
        priority
      } = _ref2;
      const permissionConfig = permission();
      if (permissionConfig) {
        app.registry.registerPermission(permissionConfig, type, priority);
      }
    });
    if (this.customPage) {
      app.registry.registerPage(this.customPage);
    }
    app.generalIndex.for(extension.name);
    Object.keys(this.generalIndexes).forEach(key => {
      if (key !== 'settings' && key !== 'permissions') return;
      const callback = this.generalIndexes[key];
      if (callback) {
        app.generalIndex.add(key, callback());
      }
    });
  }
}
flarum.reg.add('core', 'common/extenders/Admin', Admin);